import React from 'react';
import { useParams } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Tab, Tabs } from "@curves/ui-base";
import { CLUB_DOCUMENTS_ROUTER } from '@icoach/router/routerPath';
import { TRANSFERIN_ENTEREDTYPE } from '@icoach/constants/';

const MembershipTransferInSearchBarTabs = React.forwardRef((props, ref) => {
	const { enteredType } = useParams();

	return (
		<Tabs className="pl-2" value={enteredType} variant="scrollable" allowScrollButtonsMobile>
			<Tab className={'pt-3'} label={'未移入'} value={TRANSFERIN_ENTEREDTYPE.UNENTERED} component={NavLink} to={CLUB_DOCUMENTS_ROUTER.TRANSFERIN.GET_ENTEREDTYPE_PATH(TRANSFERIN_ENTEREDTYPE.UNENTERED)} />
			<Tab className={'pt-3'} label={'已移入'} value={TRANSFERIN_ENTEREDTYPE.ENTERED} component={NavLink} to={CLUB_DOCUMENTS_ROUTER.TRANSFERIN.GET_ENTEREDTYPE_PATH(TRANSFERIN_ENTEREDTYPE.ENTERED)} />
		</Tabs>
	);
});

export default MembershipTransferInSearchBarTabs;
